module.exports = __webpack_public_path__ + "media/images/home/flow_p_4-0ce70dd65179d41a4f8386dbb84d1b93.svg";